export const eventCategories = {
    FORMS: "Forms",
};

export const eventActions = {
    CLICKED: "Clicked",
};
